import type { ComponentProps } from "react";
import { cn } from "@/lib/utils";

function Alert({ className, ...props }: ComponentProps<"div">) {
  return (
    <div
      role="status"
      className={cn(
        "relative w-full rounded-2xl border border-border bg-muted/60 px-4 py-3 text-sm text-foreground",
        className
      )}
      {...props}
    />
  );
}

function AlertTitle({ className, ...props }: ComponentProps<"h5">) {
  return <h5 className={cn("mb-1 font-semibold leading-none tracking-tight", className)} {...props} />;
}

function AlertDescription({ className, ...props }: ComponentProps<"div">) {
  return <div className={cn("text-muted-foreground [&_p]:leading-relaxed", className)} {...props} />;
}

export { Alert, AlertDescription, AlertTitle };
